import React from "react";
import PropTypes from "prop-types";

const HelloWorld = ({ name }) => {
  return <h1>Hello, {name}!</h1>;
};

HelloWorld.propTypes = {
  name: PropTypes.string,
};

export default HelloWorld;
